type CardButtonProps = {
  onClick?: () => void;
  id: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  icon: React.JSXElementConstructor<{ className: string }>;
};

const CardButton = ({ onClick, id, icon: Icon, title, description }: CardButtonProps) => {
  return (
    <div
      className='bg-surface-default border-outline-default flex cursor-pointer flex-col gap-2 rounded-lg border px-4 py-3 hover:opacity-80'
      onClick={onClick}
      id={id}
    >
      <Icon className='h-6! w-6!' />
      <span className='text-content-title text-base font-semibold'>{title}</span>
      {description && <span className='text-content-body text-sm'>{description}</span>}
    </div>
  );
};

export default CardButton;
